import { render, staticRenderFns } from "./StatisticsHome.vue?vue&type=template&id=c9af4680&"
import script from "./StatisticsHome.vue?vue&type=script&lang=js&"
export * from "./StatisticsHome.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports